module.exports = __webpack_public_path__ + "static/background-learn-more-db6ceabb8bdf5ceb77909b22cc2afdb8.png";